import { ActionFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api";
import { AddLectureToBookmarkGroupRequest } from "@/routes/bookmarks/types/addLectureToBookmarkGroupRequest";

export async function lectureAction({ request, params }: ActionFunctionArgs) {
  const { courseId, lectureId } = params;
  const formData = await request.formData();
  const intent = formData.get("intent");
  if (!courseId || !lectureId) {
    throw new Error("Course ID and Lecture ID are required");
  }

  switch (intent) {
    case "mark-complete": {
      const lectureIdToMark = formData.get("lectureId") as string;
      const isCompleted = formData.get("isCompleted") === "true";
      try {
        if (isCompleted) {
          await apiEndpoints.markLectureIncomplete(lectureIdToMark);
        } else {
          await apiEndpoints.markLectureComplete(lectureIdToMark);
        }
        return { success: true };
      } catch (error) {
        console.error("Ders durumu güncellenirken hata:", error);
        return { success: false, error: "Ders durumu güncellenemedi" };
      }
    }

    case "addBookmark": {
      const bookmarkGroupId = formData.get("bookmarkGroupId") as string;
      const bookMarkData: AddLectureToBookmarkGroupRequest = {
        lectureId: lectureId,
        bookmarkGroupId: bookmarkGroupId,
      };
      try {
        await apiEndpoints.addLectureToBookmarkGroup(bookMarkData);
        return { success: true };
      } catch (error) {
        return { success: false, error: "Bookmark could not be added" };
      }
    }

    default:
      throw new Error(`Unknown intent: ${intent}`);
  }
}
